export default __webpack_public_path__ + "static/media/ettinabuja.5f83d2ec.jpg";